import React from 'react'

const Move = (props) => (
  <svg width={23} height={20} {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M4.555 1L2.826 4.019H2a1 1 0 00-1 1V18a1 1 0 001 1h19a1 1 0 001-1V5.019a1 1 0 00-1-1h-8.886L10.386 1H4.555z"
        stroke="#222222"
        strokeWidth={2}
      />
      <path
        stroke="#222222"
        fill="#222222"
        d="M14.153 10.938l-2.527-2.75a.491.491 0 010-.653.4.4 0 01.6 0l3.25 3.539a.491.491 0 010 .652l-3.25 3.539a.4.4 0 01-.6 0 .491.491 0 010-.653l2.527-2.75h-5.11A.453.453 0 018.6 11.4c0-.255.198-.462.443-.462h5.11z"
      />
    </g>
  </svg>
)

export default Move
